export default (...fieldFetchingStates) => {
  // State args is an array of objects with three keys
  // 1 - fetching, 2 - error, 3 - resource
  // ex: In: [{ resource: 'foo', fetching: false, error: 'Unauthorized }]
  // Out: { 'foo': { fetching: false, error: 'Unauthorized' } }
  const formFetchingState = fieldFetchingStates.reduce((prev, current) => {
    const obj = { ...prev };
    const { resource, ...rest } = current;
    obj[resource] = { ...rest };
    return obj;
  }, {});

  const formReady = !Object.values(formFetchingState).some(state => state.fetching);

  const formErrored = Object.values(formFetchingState).some(state => state.error);

  return [formReady, formErrored, formFetchingState];
};
